<img [attr.src]="mediaUrl | secureImage | async" class="media-picture" />
